export enum Currency {
  NAIRA = 'NGN',
}
